import api from "./api";

const createFormData = (data, imageFile) => {
  const formData = new FormData();
  Object.keys(data).forEach((key) => {
    if (data[key] !== undefined && data[key] !== null) {
      formData.append(key, data[key]);
    }
  });
  if (imageFile) {
    formData.append("image", imageFile);
  }
  return formData;
};

const examMasterService = {
  // Exam Categories
  getExamCategories: async () => {
    const response = await api.get("/api/exam-master/categories");
    return response.data.data;
  },

  getActiveExamCategories: async () => {
    const response = await api.get("/api/exam-master/categories/active");
    return response.data.data;
  },
  
  createExamCategory: async (data, imageFile = null) => {
    if (imageFile) {
      const formData = createFormData(data, imageFile);
      const response = await api.post("/api/exam-master/categories", formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      return response.data.data;
    }
    const response = await api.post("/api/exam-master/categories", data);
    return response.data.data;
  },

  updateExamCategory: async (id, data, imageFile = null) => {
    if (imageFile || (data && data.image_url !== undefined)) {
      const formData = createFormData(data, imageFile);
      const response = await api.put(`/api/exam-master/categories/${id}`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      return response.data.data;
    }
    const response = await api.put(`/api/exam-master/categories/${id}`, data);
    return response.data.data;
  },

  deleteExamCategory: async (id) => {
    const response = await api.delete(`/api/exam-master/categories/${id}`);
    return response.data;
  },

  // Exams
  getExams: async (examCategoryId = null) => {
    const url = examCategoryId ? `/api/exam-master/exams?exam_category_id=${examCategoryId}` : "/api/exam-master/exams";
    const response = await api.get(url);
    return response.data.data;
  },

  getActiveExams: async () => {
    const response = await api.get("/api/exam-master/exams/active");
    return response.data.data;
  },

  createExam: async (data, imageFile = null) => {
    if (imageFile) {
      const formData = createFormData(data, imageFile);
      const response = await api.post("/api/exam-master/exams", formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      return response.data.data;
    }
    const response = await api.post("/api/exam-master/exams", data);
    return response.data.data;
  },

  updateExam: async (id, data, imageFile = null) => {
    if (imageFile || (data && data.image_url !== undefined)) {
      const formData = createFormData(data, imageFile);
      const response = await api.put(`/api/exam-master/exams/${id}`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      return response.data.data;
    }
    const response = await api.put(`/api/exam-master/exams/${id}`, data);
    return response.data.data;
  },

  deleteExam: async (id) => {
    const response = await api.delete(`/api/exam-master/exams/${id}`);
    return response.data;
  },

  // Competitive Subjects
  getCompetitiveSubjects: async (examId = null) => {
    const url = examId ? `/api/exam-master/subjects?exam_id=${examId}` : "/api/exam-master/subjects";
    const response = await api.get(url);
    return response.data.data;
  },

  createCompetitiveSubject: async (data, imageFile = null) => {
    if (imageFile) {
      const formData = createFormData(data, imageFile);
      const response = await api.post("/api/exam-master/subjects", formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      return response.data.data;
    }
    const response = await api.post("/api/exam-master/subjects", data);
    return response.data.data;
  },

  updateCompetitiveSubject: async (id, data, imageFile = null) => {
    if (imageFile || (data && data.image_url !== undefined)) {
      const formData = createFormData(data, imageFile);
      const response = await api.put(`/api/exam-master/subjects/${id}`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      return response.data.data;
    }
    const response = await api.put(`/api/exam-master/subjects/${id}`, data);
    return response.data.data;
  },

  deleteCompetitiveSubject: async (id) => {
    const response = await api.delete(`/api/exam-master/subjects/${id}`);
    return response.data;
  },
};

export default examMasterService;
